import { IconPhoto as TablerIconPhoto } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconPhoto = /*#__PURE__*/ createOutlineIcon(TablerIconPhoto, 'IconPhoto');
